// oeeAggregate.js — combine hourly OEE records (OEE_HOURLY_<date>/<shift>.hours) over
// any timespan. Each hour is equal time, so state %, Availability and Performance are
// hour-averages; units are summed; Quality = good / total units; OEE = A × P × Q.

const KEYS = ['producing', 'idle', 'blocked', 'starved', 'faulted', 'plannedMaintenance', 'plannedStop', 'availability', 'performance', 'avgUph'];
const mean = a => (a.length ? a.reduce((x, y) => x + y, 0) / a.length : null);
const nums = (list, k) => list.map(x => x && x[k]).filter(v => typeof v === 'number' && !Number.isNaN(v));

export function aggRow(list) {
  const rs = list.filter(Boolean);
  if (!rs.length) return null;
  const out = { ...rs[rs.length - 1], hours: rs.length };
  for (const k of KEYS) out[k] = mean(nums(rs, k));
  for (const k of ['totalUnits', 'goodUnits', 'badUnits']) { const v = nums(rs, k); out[k] = v.length ? v.reduce((a, b) => a + b, 0) : null; }
  out.quality = out.totalUnits ? (100 * (out.goodUnits || 0)) / out.totalUnits : mean(nums(rs, 'quality'));
  out.oee = out.availability != null && out.performance != null && out.quality != null ? (out.availability * out.performance * out.quality) / 10000 : mean(nums(rs, 'oee'));
  return out;
}

export function aggArea(list) {
  const as = list.filter(Boolean);
  if (!as.length) return null;
  const st = {};
  for (const k of ['producing', 'idle', 'downtime', 'blocked', 'starved']) st[k] = mean(as.map(a => a.states && a.states[k]).filter(v => typeof v === 'number'));
  const A = mean(nums(as, 'availability')), P = mean(nums(as, 'performance')), Q = mean(nums(as, 'quality'));
  return { availability: A, performance: P, quality: Q, oee: A != null && P != null && Q != null ? (A * P * Q) / 10000 : mean(nums(as, 'oee')), states: st, hours: as.length };
}

// hours: [{ ts, area, rows }] -> { area, rows, history, hours, first, last }
export function aggregateHours(hours) {
  const hs = (hours || []).filter(h => h && h.ts && Array.isArray(h.rows)).sort((a, b) => a.ts - b.ts);
  if (!hs.length) return null;
  const byMp = new Map();
  for (const h of hs) for (const r of h.rows) {
    const k = `${r.mp}|${r.description}`;
    if (!byMp.has(k)) byMp.set(k, []);
    byMp.get(k).push(r);
  }
  const rows = [...byMp.values()].map(aggRow).filter(Boolean);
  const pid = (h, d) => (h.rows || []).find(r => (r.description || '').toUpperCase() === d);
  const history = hs.map(h => ({ ts: h.ts, area: { oee: h.area && h.area.oee }, p1: pid(h, 'PID1') || null, p2: pid(h, 'PID2') || null }));
  return { area: aggArea(hs.map(h => h.area)), rows, history, hours: hs.length, first: hs[0].ts, last: hs[hs.length - 1].ts };
}
